import { render, staticRenderFns } from "./Epsgram.vue?vue&type=template&id=304a483f&"
import script from "./Epsgram.vue?vue&type=script&lang=js&"
export * from "./Epsgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports